import { CandidateOpportunitiesConst } from '@axiom/const';
import type { CandidateOpportunity } from '@axiom/validation';

const { CandidateStatuses, MLRecommendationStatuses } =
  CandidateOpportunitiesConst;

export const poolContextMenuStatusLabels: Partial<
  Record<NonNullable<CandidateOpportunity['candidateStatus']>, string>
> = {
  [CandidateStatuses.ShortList]: 'Short List',
  [CandidateStatuses.Suggested]: 'Suggest',
  [CandidateStatuses.RepBioShare]: 'Share Rep Bio',
  [CandidateStatuses.Removed]: 'Remove',
  [CandidateStatuses.InterestedRejected]: 'Interested - Reject',
  [MLRecommendationStatuses.AiRemoved]: 'AI Match - Remove',
};

export const positionContextMenuStatusLabels: Partial<
  Record<NonNullable<CandidateOpportunity['candidateStatus']>, string>
> = {
  [CandidateStatuses.Cooled]: 'Cool',
  [CandidateStatuses.Interviewing]: 'Interview',
  [CandidateStatuses.Rejected]: 'Not Selected',
  [CandidateStatuses.Removed]: 'Remove',
  [CandidateStatuses.RepBioShare]: 'Share Rep Bio',
  [CandidateStatuses.Selected]: 'Select',
  [CandidateStatuses.ShortList]: 'Short List',
  [CandidateStatuses.Suggested]: 'Suggest',
  [CandidateStatuses.TalentOptOut]: 'Talent Opt Out',
  [CandidateStatuses.Warmed]: 'Warm',
  [CandidateStatuses.WarmedYes]: 'Opt Talent In',
  [CandidateStatuses.InterestedRejected]: 'Interested - Reject',
};
